import {useEffect, useRef, useState, useCallback} from 'react';

export function usePolling(fetchFn, intervalMs, {enabled = true} = {}) {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const fetchFnRef = useRef(fetchFn);
    fetchFnRef.current = fetchFn;

    const refetch = useCallback(async () => {
        try {
            setIsLoading(true);
            const result = await fetchFnRef.current();
            setData(result);
            setError(null);
            return result;
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!enabled) return;

        let cancelled = false;

        const poll = async () => {
            try {
                const result = await fetchFnRef.current();
                if (!cancelled) {
                    setData(result);
                    setError(null);
                }
            } catch (err) {
                if (!cancelled) setError(err);
            }
        };

        poll();
        const interval = setInterval(poll, intervalMs);
        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, [intervalMs, enabled]);

    return {data, error, isLoading, refetch};
}
